import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  padding: 20px;
  width: 100%;
`;

export const PaymentInfos = styled.div`
  max-width: 400px;
  width: 100%;
`;

export const ReplaceOtherCardText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `};
`;

export const CheckboxContainer = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    display: flex;
    font-size: ${theme.v2.font.sizes.xxs};
    gap: 8px;
  `};
`;

export const Iframe = styled.iframe`
  max-width: 400px;
  border: none;
`;

export const SelectContainer = styled.div`
  padding: 0 10px;
  width: 100%;
`;

export const BottomMessage = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 4px;
    display: flex;
    gap: 8px;
    padding: 8px;
    width: 100%;
  `};
`;

export const BottomMessageText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;
